<template>
  <q-btn
    icon="fa fa-clock"
    text-color="amber-10"
    title="Click for more information"
    v-bind="$attrs"
    rounded
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ReconnectRequest } from '@/social/types';
import openModal from '@/components/modal';
import ViewRequestModal from './ViewRequestModal.vue';

export default defineComponent({
  props: {
    request: {
      type: Object as () => ReconnectRequest,
      required: true,
    },
    platform: {
      type: String,
      required: true,
    },
  },
  methods: {
    openModal() {
      const config = { parent: this, request: this.request, platform: this.platform };
      openModal(ViewRequestModal, config);
    },
  },
});
</script>
